import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Logo from '../../../assets/proofpoint-logo-white.svg';
import PropTypes from 'prop-types';
import ProofpointCopyright from './proofpoint-copyright';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    card: {
        marginBottom: theme.spacing.unit * 2,
        width: 480
    },
    cardContent: {
        padding: '24px 44px 40px'
    },
    cardHeader: {
        backgroundColor: theme.palette.primary[800],
        height: 56,
        paddingBottom: 5,
        textAlign: 'center'
    },
    description: {
        color: theme.palette.text.secondary,
        margin: '24px 0 16px'
    },
    root: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        height: '100vh',
        marginTop: ( theme.spacing.unit * 2 ) * -1
    },
} );


const MaintenancePage = ( { classes } ) => (
    <div className={classes.root}>
        <Card className={classes.card}>
            <CardHeader
                className={classes.cardHeader}
                title={(
                    <img
                        src={Logo}
                        alt="Proofpoint Logo"
                        height={24}
                        className="logo"
                    />
                )}
            />
            <CardContent className={classes.cardContent}>
                <Typography align="center" variant="h5" data-automation-id="maintenance-card-title">
                            Email Fraud Defense Maintenance
                </Typography>
                <Typography align="left" className={classes.description} data-automation-id="maintenance-card-description">
                        We are undergoing a scheduled maintenance starting at 10 PM MDT (UTC - 06:00).
                        Sorry for the inconvenience.
                        We’ll be back up and running as fast as possible.
                </Typography>
            </CardContent>
        </Card>
        <ProofpointCopyright />
    </div>
);

MaintenancePage.propTypes = {
    classes: PropTypes.object,
};

export default withStyles( styles )( MaintenancePage );
